import { Box, Button, Divider, Skeleton, Stack, Typography } from "@mui/material";
import RestartAltRoundedIcon from "@mui/icons-material/RestartAltRounded";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";

export default function StoreSidebarFilters({
  sections,
  categories,
  selectedSection,
  selectedCategory,
  onSectionChange,
  onCategoryChange,
  onClear,
  loadingCategories,
}) {
  return (
    <Box
      sx={{
        borderRadius: { xs: "22px", md: "24px" },
        bgcolor: "#ffffff",
        border: "1px solid rgba(0,0,0,0.08)",
        boxShadow: "0 12px 28px rgba(0,0,0,0.04)",
        overflow: "hidden",
        width: "100%",
      }}
    >
      <Box
        sx={{
          px: { xs: 1.7, sm: 2 },
          py: { xs: 1.5, sm: 1.7 },
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid rgba(0,0,0,0.06)",
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: 21, sm: 24 },
            fontWeight: 800,
            color: "#111111",
            lineHeight: 1,
            textAlign: "left",
          }}
        >
          Filtrar
        </Typography>

        <TuneRoundedIcon sx={{ color: "#111111", fontSize: { xs: 21, sm: 23 } }} />
      </Box>

      <Box sx={{ p: { xs: 1.5, sm: 1.8 } }}>
        <Typography
          sx={{
            mb: 1,
            fontSize: 12.8,
            fontWeight: 800,
            color: "#111111",
            letterSpacing: 0.3,
            textAlign: "left",
          }}
        >
          SECCIONES
        </Typography>

        <Stack spacing={0.5}>
          <Button
            onClick={() => onSectionChange("")}
            sx={filterButtonSx(!selectedSection)}
          >
            <Box
              component="span"
              sx={{
                width: "100%",
                textAlign: "left",
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: 1.35,
              }}
            >
              Todas
            </Box>
          </Button>

          {sections.map((section) => {
            const active = String(section.id) === String(selectedSection);

            return (
              <Button
                key={section.id}
                onClick={() => onSectionChange(section.id)}
                sx={filterButtonSx(active)}
              >
                <Box
                  component="span"
                  sx={{
                    width: "100%",
                    textAlign: "left",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    lineHeight: 1.35,
                  }}
                >
                  {section.name}
                </Box>
              </Button>
            );
          })}
        </Stack>

        <Divider sx={{ my: 1.8, borderColor: "rgba(0,0,0,0.08)" }} />

        <Typography
          sx={{
            mb: 1,
            fontSize: 12.8,
            fontWeight: 800,
            color: "#111111",
            letterSpacing: 0.3,
            textAlign: "left",
          }}
        >
          CATEGORÍAS
        </Typography>

        <Box
          sx={{
            minHeight: 56,
            maxHeight: { xs: 250, sm: 290, md: 320 },
            overflowY: "auto",
            pr: 0.4,
            mr: -0.4,
            scrollbarWidth: "thin",
            scrollbarColor: "rgba(17,17,17,0.22) transparent",
            "&::-webkit-scrollbar": {
              width: "7px",
            },
            "&::-webkit-scrollbar-track": {
              background: "transparent",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "rgba(17,17,17,0.18)",
              borderRadius: "999px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "rgba(17,17,17,0.28)",
            },
          }}
        >
          {loadingCategories ? (
            <Stack spacing={0.6}>
              {[1, 2, 3, 4].map((item) => (
                <Skeleton
                  key={item}
                  variant="rounded"
                  height={44}
                  sx={{ borderRadius: "14px" }}
                />
              ))}
            </Stack>
          ) : (
            <Stack spacing={0.5}>
              <Button
                onClick={() => onCategoryChange("")}
                sx={filterButtonSx(!selectedCategory)}
              >
                <Box
                  component="span"
                  sx={{
                    width: "100%",
                    textAlign: "left",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    lineHeight: 1.35,
                  }}
                >
                  Todas
                </Box>
              </Button>

              {categories.map((category) => {
                const active = String(category.id) === String(selectedCategory);

                return (
                  <Button
                    key={category.id}
                    onClick={() => onCategoryChange(category.id)}
                    sx={filterButtonSx(active)}
                  >
                    <Box
                      component="span"
                      sx={{
                        width: "100%",
                        textAlign: "left",
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        lineHeight: 1.35,
                      }}
                    >
                      {category.name}
                    </Box>
                  </Button>
                );
              })}
            </Stack>
          )}
        </Box>

        <Button
          fullWidth
          onClick={onClear}
          startIcon={<RestartAltRoundedIcon />}
          sx={{
            mt: 2,
            minHeight: 50,
            px: 1.5,
            py: 1,
            borderRadius: "15px",
            textTransform: "none",
            fontSize: { xs: 14, sm: 14.1 },
            fontWeight: 800,
            color: "#111111",
            bgcolor: "#ffffff",
            border: "1px solid rgba(17,17,17,0.10)",
            justifyContent: "flex-start",
            "& .MuiButton-startIcon": {
              mr: 1,
            },
            "&:hover": {
              color: "#e50914",
              bgcolor: "rgba(229,9,20,0.04)",
              borderColor: "rgba(229,9,20,0.16)",
            },
          }}
        >
          Limpiar filtros
        </Button>
      </Box>
    </Box>
  );
}

function filterButtonSx(active) {
  return {
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "100%",
    minHeight: 48,
    px: 1.2,
    py: 1,
    borderRadius: "14px",
    textTransform: "none",
    fontSize: { xs: 14.1, sm: 14.2 },
    fontWeight: active ? 800 : 700,
    color: active ? "#e50914" : "#111111",
    bgcolor: active ? "rgba(229,9,20,0.08)" : "transparent",
    transition: "background-color 0.18s ease, color 0.18s ease",
    "&:hover": {
      bgcolor: active ? "rgba(229,9,20,0.10)" : "rgba(17,17,17,0.04)",
    },
  };
}